export class TeamHolidaysModel {

    public items: TeamHolidaysItemModel[] = [];
    public extraTitles: string[] = [];

}

export class TeamHolidaysItemModel {

    public userId: number;
    public userName: string;
    public yearlyVacationCount: string;
    public rolledVacationCount: string;
    public usedUpVacationCount: string;
    public remainingVacationCount: string;
    public otherItems: string[] = [];

}